var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center fill-height"},[_c('v-card',{staticClass:"d-flex radius_shadow ma-2",attrs:{"max-width":"1300","height":"96%"}},[_c('Initial',{on:{"next":_vm.next}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }